/**
 * @file operations-frontend/src/utils/documents.ts
 * @description Utils for Documents
 */

/** Regular expression for file name */
export const fileNameRegex = /^(\w+|\w+[\w\s-]*|\w+[\w\s-]*\/\w+[\w\s-]*)[^\s/]$/gi

/**
 * Get the file extension for a given file name
 * @param fileName The name of the file
 * @returns The file extension
 */
export const getFileExt = (fileName: string) => fileName.split('.').pop()

/**
 * Download a blob as a file
 * @param blob
 * @param filename
 */
export function downloadBlob(blob: Blob, filename: string) {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}
